import { Backdrop, Button, CircularProgress, Dialog, DialogActions } from "@mui/material";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { IInfoCard } from "../../components/class";
import { useDeleteInfoCardMutation } from "../services/booth";

export interface EventDeleteDialogProps {
    open: boolean;
    data: IInfoCard;
    onClose?: () => void;
    onDelete?: () => void;
}
export default function EventDeleteDialog(props: EventDeleteDialogProps) {
    const { open, data, onClose, onDelete } = props;
    const { t } = useTranslation();

    const [deleteCard, { isLoading }] = useDeleteInfoCardMutation();
    async function handleDelete() {
        try {
            let result = await deleteCard(data.dataId).unwrap();
            if (!result.isSuccess)
                throw new Error("刪除資料失敗");
            if (onDelete) onDelete();
        }
        catch (e) {
            console.error(e);
        }
    }
    return (<>
        <Dialog open={open} onClose={onClose}>
            <div style={{ padding: '2rem 2rem 1rem 2rem', textAlign: 'center', fontSize: '1rem' }} >
                <span style={{ fontWeight: 'bold' }}>
                    <Trans i18nKey="infoCard.hint.delete" values={{ title: data?.title }} />
                </span>
            </div>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button autoFocus onClick={handleDelete}>{t('common.button.yes')}</Button>
                <Button onClick={onClose}>{t('common.button.no')}</Button>
            </DialogActions>
        </Dialog>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }} open={isLoading}>
            <CircularProgress color="inherit" />
        </Backdrop>
    </>)
}